<template>
  <div style='overflow-x: hidden;'>
    <el-menu
      ref="sideBar"
      :default-openeds="acitiveAddress"
      class="el-menu-vertical-demo"
      :background-color="dark ? '#06101D' : ''"
      :text-color="dark ? '#FFFFFFD9' : ''"
      :active-text-color="dark ? '#00DADAFF' : ''"
    >
      <sidebar-item :routes="areaAll" :dark='dark'></sidebar-item>
    </el-menu>
  </div>
</template>

<script>
import SidebarItem from './sidebarItem2'
import { mapGetters } from 'vuex'
import { Loading } from 'element-ui'

export default {
  name: 'sidebar2',
  props: {
    dark: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      routes: [],
      loadingInstance: undefined
    }
  },
  computed: {
    ...mapGetters([
      'areaAll',
      'globaleSelfAreaId',
      'user',
      'selfAreaId',
      'sideBarLoading',
      'userSelfAreaId'
    ]),
    acitiveAddress() {
      if (!this.globaleSelfAreaId) {
        return ['000000']
      }
      const ps = this.globaleSelfAreaId.slice(0, 2) + '0000'
      const cs = this.globaleSelfAreaId.slice(0, 4) + '00'
      const as = this.globaleSelfAreaId
      return [ps, cs, as]
    }
  },
  watch: {
    sideBarLoading(val) {
      console.log('sideBarLoading', val)
      if (val) {
        this.onLoading()
      } else {
        this.offLoading()
      }
    }
  },
  methods: {
    onLoading() {
      const options = {
        target: this.$refs.sideBar.$el
      }
      this.loadingInstance = Loading.service(options)
    },
    offLoading() {
      this.loadingInstance && this.loadingInstance.close()
    }
    // 改变用户areaid
    // const userId = {
    //   key: 'selfAreaId',
    //   value: key
    // }
    // store.commit('user/setUserInfo', userId)
  },
  components: {
    SidebarItem
  }
}
</script>

<style scoped lang="less">
.el-menu{
  border-right:0;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 180px;
  // min-height: 400px;
}
</style>
